<template>
    <div>
        <b-row v-if="loading">
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-4"
                />
            </b-col>
        </b-row>
        <div class="animated fadeIn">
            <loader v-if="loading"></loader>
            <div v-if="!loading">
                <component-header
                    title="Closed Service Tickets"
                    :isLoading="isloading"
                    :hasCreate="false"
                    :hasReload="false"
                    :hasback="false"
                    @search-query="(val) => (filter = val)"
                />
                <b-card class="card-wrap" border-variant="info">
                    <div>
                        <b-table
                            style="border-radius: 12px"
                            :dark="false"
                            :hover="true"
                            :striped="false"
                            :bordered="true"
                            :small="false"
                            :fixed="false"
                            responsive
                            :filter="filter"
                            :items="ticketItemList"
                            :fields="ticketListColumns"
                            :current-page="currentPage"
                            :per-page="perPage"
                            thead-class="header"
                            show-empty
                        >
                            <template slot="cell(empty)">
                                <div v-if="isloading" class="text-center">
                                    <span><b>Loading...</b></span>
                                </div>
                                <div v-else class="text-center">
                                    No data available.
                                </div>
                            </template>

                            <template slot="cell(action)" slot-scope="data">
                                <div class="inline_btnTable">
                                    <b-button
                                        size="sm"
                                        class="mr-2 button-circle"
                                        variant="primary"
                                        @click="viewTicket(data.item.restData)"
                                    >
                                        <i class="fa fa-eye edit"></i>
                                    </b-button>
                                </div>
                            </template>
                        </b-table>
                    </div>
                    <div class="float-right">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="ticketItemList.length"
                            aria-controls="my-table"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                        ></b-pagination>
                    </div>
                </b-card>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
import loader from "@/components/loader/nipigeloader.vue";
import moment from "moment";

export default {
    name: "CustomerClosedTickets",
    data() {
        return {
            filter: "",
            loading: false,
            isloading: false,
            currentPage: 1,
            perPage: 8,
            ticketListColumns: [
                {
                    key: "number",
                },
                {
                    key: "customerName",
                },
                {
                    key: "category",
                },
                {
                    key: "subject",
                },
                {
                    key: "assignTo",
                    label: "Assigned To",
                },
                {
                    key: "status",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    components: {
        ebButton,
        ComponentHeader,
        loader,
        AtomSpinner,
    },

    computed: {
        ...mapGetters({
            getOpenServiceTicket: "serviceticket/GetOpenServiceTicket",
        }),
        ticketItemList() {
            try {
                let data = this.getOpenServiceTicket;
                let ticketList = [];
                if (Array.isArray(data) && data.length > 0) {
                    data.map((obj) => {
                        try {
                            if (obj.status == "CLOSED") {
                                let arrObj = {
                                    number: obj.ticketNo,
                                    customerName: obj.reportedBy.name
                                        ? obj.reportedBy.name
                                        : "",
                                    status: obj.status,
                                    category: obj.category
                                        ? obj.category.name
                                        : "-",
                                    subject: obj.subject,
                                    assignTo: obj.assignTo
                                        ? obj.assignTo.name
                                        : "-",
                                    restData: obj,
                                };

                                ticketList.push(arrObj);
                            }
                        } catch (err) {}
                    });
                    return ticketList.sort(
                        (a, b) =>
                            new Date(b.restData.updatedAt) -
                            new Date(a.restData.updatedAt),
                    );
                } else {
                    return [];
                }
            } catch (err) {
                return [];
            }
        },
    },

    methods: {
        viewTicket(data) {
            this.$router.push({
                name: "view-service-ticket ",
                params: { id: data._id },
            });
        },
        getProperDate(data) {
            if (data != null) {
                let date = new Date(data);

                return moment(String(date)).format("DD/MM/YYYY");
            } else {
                return "Unavailable";
            }
        },
    },

    async mounted() {
        this.loading = true;
        const payload = {
            id: "",
        };
        if (this.$currentUserData.category === "SELLER") {
            payload.id = this.$currentUserData._id;
        }
        await this.$store.dispatch(
            "serviceticket/openServiceTicketAction",
            payload,
        );
        this.loading = false;
    },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
